import { render, staticRenderFns } from "./Vanswer.vue?vue&type=template&id=1e3f6993"
import script from "./Vanswer.vue?vue&type=script&lang=js"
export * from "./Vanswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports